module.exports = __webpack_public_path__ + "static/media/zameen-map-search.694fd715.jpg";